/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * The type of the attribute
 */
export type AdditionalAttributeDtoAttributeType =
  (typeof AdditionalAttributeDtoAttributeType)[keyof typeof AdditionalAttributeDtoAttributeType];

export const AdditionalAttributeDtoAttributeType = {
  PROPERTY: 'property',
  REALTIME: 'realTime',
} as const;
